/** The codelist resolving the reason a rental vehicle is blocked for */
export const VEHICLE_BLOCK_CODELIST_ID = 'vehicleBlock';
